import { Thermostat } from './thermostat.model';

export class OTM extends Thermostat {
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
}
